import { CHANGE_OF_TYPES } from "@/constants/config";
import { generateRandomUniqueId } from "@/helpers";

const getLabel = payload => {
    let idTypeLabel = null;
    const idType = payload.id_type ?? payload.director_user.user_info.id_type;

    if(idType.name === 'NRIC (Citizen)' || idType.name === 'NRIC (PERMANENT RESIDENT)')
        idTypeLabel = 'NRIC';
    else if(idType.name.toUpperCase() === 'FIN')
        idTypeLabel = 'FIN';
    else idTypeLabel = 'PASSPORT';

    return idTypeLabel;
};

const getUpdatedList = (data, payload) => data.map(particular => {
    let label = particular.change_of_type;

    if(particular.change_of_type === CHANGE_OF_TYPES.PASSPORT) {
        label = getLabel(payload);
    }

    if(particular.change_of_type === CHANGE_OF_TYPES.ADDRESS) {
        label = 'Address';
    }
    
    return {
        _id: generateRandomUniqueId(),
        changeOfType: particular.change_of_type,
        changeFrom: particular.change_from,
        changeTo: particular.change_to,
        label,
    };
});

const getSelectedDirector = director => ({
    id: director.id,
    userId: director.id,
    nric: director.user_info.NRIC,
    name: director.user_info?.legal_name ?? director.name,
    email: director.email,
    contactNumber: director.user_info.contact_number,
    address: director.user_info.address,
});

const localize = payload => ({
    id: payload.id,
    companyProcessId: payload.company_process.id,
    director: {
        userId: payload.director_user.id,
        name: payload.director_user.user_info.legal_name,
        nric: payload.director_user.user_info.NRIC,
    },

    updatedDirectorParticularList: getUpdatedList(payload.updated_particular_list, payload),
    selectedDirectorData: getSelectedDirector(payload.director_user),
});

export default localize;